import { SupportedNetwork } from '@spritz-finance/sdk'
import { Body, Button, colors, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import { useScreenSize } from '../context/useScreenSize'
import { noSelect } from '../utils/noSelect'
import { useWalletDialog } from './connectDialog/WalletConnectDialogProvider'
import { getWalletType } from './connection/utils'
import { networkColors } from './networkColors'
import { NetworkSwitcher } from './networkSwitcher/NetworkSwitcher'
import { maskedAddress } from './utils/maskedAddress'
import { useEnsDomain } from './utils/useEnsDomain'
import { WalletLogo } from './WalletLogo'
import { useWeb3Connection } from './Web3Provider'

const TextContainer = styled.div`
    ${noSelect};
    display: flex;
    flex-direction: column;
`

const ConnectedWallet = styled.div<{ $mobile?: boolean; $clickable?: boolean }>`
    background: var(--wallet-pill, ${colors.white});
    border-radius: 14px;
    padding: ${({ $mobile }) => ($mobile ? '4px 12px' : '12px')};
    ${({ $clickable }) =>
        $clickable &&
        css`
            cursor: pointer;
        `}
    display: flex;
    align-items: center;
    justify-content: center;
`

const WalletContainer = styled.div<{ $network: SupportedNetwork | null }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    box-shadow: 20px 20px 30px rgb(0 0 0 / 10%);
    transition: background 0.3s ease-in-out;
    padding: 4px;
    background: ${({ $network }) =>
        `var(--wallet-background, ${
            $network ? networkColors[$network].bgLight : colors.silverGray
        })`};
`

export const Wallet = ({
    responsive = false,
    clickable = true,
}: {
    responsive?: boolean
    clickable?: boolean
}) => {
    const { isMobile } = useScreenSize()
    const ensDomain = useEnsDomain()
    const { openWalletConnectDialog } = useWalletDialog()
    const { account, connector, connectedNetwork } = useWeb3Connection()
    const walletType = getWalletType(connector)
    const mobileStyle = responsive && isMobile

    if (!account) {
        return (
            <Button.CTA onClick={() => openWalletConnectDialog()} variant="gradient">
                Connect wallet
            </Button.CTA>
        )
    }

    return (
        <WalletContainer $network={connectedNetwork}>
            <NetworkSwitcher mobileStyle={mobileStyle} />
            <ConnectedWallet
                $clickable={clickable}
                onClick={() => {
                    if (clickable) openWalletConnectDialog()
                }}
                $mobile={mobileStyle}
            >
                <WalletLogo walletType={walletType} />
                <Spacer width={8} />
                <TextContainer>
                    <Body.SmBold size={mobileStyle ? 14 : 16}>
                        {ensDomain || maskedAddress(account)}
                    </Body.SmBold>
                </TextContainer>
            </ConnectedWallet>
        </WalletContainer>
    )
}
